import React, { useRef } from "react";
import "./index.css";

import constants from "../../../constants";
import messages from "../../../constants/messages";
import SpinnerBorder from "../../uiElements/loadingSpinner/SpinnerBorder";

/* eslint-disable jsx-a11y/anchor-is-valid */

const FileAttachment = ({ name, onChange, onError, files, onRemove, isLoading=false }) => {
  const loader = useRef(null);
  let inputElement;

  const handleFile = (e) => {
    const file = e.target.files;
    const maxAllowedSize = 5 * 1024 * 1024; // 5MB size limit

    if (file[0].size > maxAllowedSize) {
      onError(messages.MAX_FILE_SIZE);
    } else if (
      !constants.DOCUMENT_SUPPORTED_TYPES.includes(
        file[0].name.split(".").pop().toLowerCase()
      )
    ) {
      onError(messages.INVALID_DOCUMENT);
    } else {
      const uploadedFiles = Array.from(file);
      onChange({
        [name]: files ? [...files, ...uploadedFiles] : uploadedFiles,
      });
    }

    // Reset the input value to allow re-upload of the same file
    e.target.value = null;
  };

  const handleRemove = (index) => {
    const newFiles = [...files];
    if (newFiles[index]?.src) {
      onRemove(newFiles[index]);
    }

    newFiles.splice(index, 1);
    onChange({ [name]: newFiles });
  };

  const icon = (
    <svg
      width="27"
      height="27"
      viewBox="0 0 18 18"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.5V16.5M1.5 9H16.5"
        stroke="var(--icon-color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <>
      <div className="chat_attachment">
        {isLoading ? 
        <div>
          <SpinnerBorder size="lg" style={{color: '#FF872C'}}/>
        </div>
        :
        <div>
          <input
          ref={(input) => (inputElement = input)}
          accept="application/pdf,image/png,image/jpg,image/jpeg"
          type="file"
          style={{ display: "none" }}
          onChange={handleFile}
          />
          <div ref={loader}></div>
          <div>
            <a onClick={() => inputElement.click()}>{icon}</a>
          </div>
        </div>}
      </div>
    </>
  );
};

export default React.memo(FileAttachment);
